<template>
  <div class="tabs">
    <div class="tabs__list">
      <div class="tabs__list-item"
           v-for="tab in tabs"
           :class="{ 'tabs__list-item--active' : tab.isActive }"
           @click="selectTab(tab.id)">
        {{ tab.name }}
      </div>
    </div>
    <div class="tabs__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tabs: null
      }
    },
    created () {
      this.tabs = this.$children
    },
    methods: {
      selectTab (id) {
        this.tabs.forEach(tab => {
          tab.isActive = tab.id === id
          if (tab.isActive) {
            this.$emit('input', tab.name)
          }
        })
      }
    },
    mounted () {
      this.selectTab(this.tabs[0].id)
    }
  }
</script>

<style lang="scss">
  .tabs {
    display: flex;
    flex-direction: column;

    &__list {
      display: flex;
      justify-content: center;
    }

    &__list-item {
      padding: 10px 15px;
      cursor: pointer;
      text-transform: uppercase;
      font-weight: bold;
      color: color(grays, light);
      border-bottom: 1px solid color(grays, extra-light);

      & + & {
        border-left: 1px solid color(grays, extra-light);
      }

      &--active {
        color: color(blues, normal);
        cursor: default;
      }
    }

    &__content {
      position: relative;
      height: calc(100% - 43px);
    }
  }
</style>



// WEBPACK FOOTER //
// Tabs.vue?8fa5f196